import { apiClient } from '../api';
import { getAccessToken, getActiveUserId } from './dashboard';

const currentUser = () =>
  apiClient
    .get(`/CurrentUser?userId=${getActiveUserId()}`, {
      headers: { Authorization: getAccessToken() }
    })
    .then(response => response.data);

const loggedInUser = () =>
  apiClient
    .get(`/CurrentUser`, {
      headers: { Authorization: getAccessToken() }
    })
    .then(response => response.data);

const getUsers = () =>
  apiClient
    .get(`/Users`, {
      headers: { Authorization: getAccessToken() }
    })
    .then(response => response.data);

const getCertifiedDate = () =>
  apiClient
    .get(`/CertifiedDate?userId=${getActiveUserId()}`, {
      headers: { Authorization: getAccessToken() }
    })
    .then(response => response.data);

export default {
  loggedInUser,
  currentUser,
  getUsers,
  getCertifiedDate
};
